import Http from '@/api/http.js'

export default {
  index(filter){
    return Http.get(`/incomes_extract`, {params: {...filter}});
  },


  index_confirmation(){
    return Http.get(`/income_extract_confirmations`);
  },
  create_confirmation(income_extract){
    return Http.post(`/income_extract_confirmations`, {
      income_extract_confirmation: {...income_extract}
    });
  },
  update_confirmation(income_extract){
    return Http.put(`/income_extract_confirmations/${income_extract.id}`, {
      income_extract_confirmation: {...income_extract}
    });
  },

  delete_confirmation(income_extract_id){
    return Http.delete(`/income_extract_confirmations/${income_extract_id}`);
  },
}